import type { Control, ILaneConfig, LaneConfig } from 'commons';

/**
 * Action to add a new lane configuration.
 */
export class AddLaneConfig {
  static readonly type = '[Multilane] addLane';

  /**
   * @param laneConfig Optional lane configuration to add.
   * @param view Optional view associated with the lane.
   */
  constructor(
    public readonly laneConfig?: LaneConfig,
    public readonly view?: string
  ) {}
}

/**
 * Action to update an existing lane configuration.
 */
export class UpdateLaneConfig {
  static readonly type = '[MultiView] Update Lane Config';

  /**
   * @param laneConfig The lane configuration to update.
   */
  constructor(public laneConfig: LaneConfig | ILaneConfig) {}
}

/**
 * Action to add a control to a lane configuration.
 */
export class AddControlToLaneConfig {
  static readonly type = '[MultiView] Add Control To Lane Config';

  /**
   * @param control The control to add.
   * @param lane Optional lane configuration to which the control will be added.
   */
  constructor(
    public control: Control,
    public lane?: LaneConfig | ILaneConfig
  ) {}
}

/**
 * Action to remove a control from a lane configuration.
 */
export class RemoveControlFromLaneConfig {
  static readonly type = '[MultiView] Remove Control From Lane Config';

  /**
   * @param control The control to remove.
   * @param lane The lane configuration from which the control will be removed.
   */
  constructor(
    public control: Control,
    public lane: LaneConfig
  ) {}
}

/**
 * Action to remove a lane configuration by its ID.
 */
export class RemoveLaneById {
  static readonly type = '[MultiView] removeLane by id';

  /**
   * @param id The ID of the lane configuration to remove.
   */
  constructor(public readonly id: string) {}
}

/**
 * Action to remove a lane configuration by its index.
 */
export class RemoveLaneByIndex {
  static readonly type = '[MultiView] removeLane by index';

  /**
   * @param index The index of the lane configuration to remove.
   */
  constructor(public readonly index: number) {}
}

/**
 * Action to reorder lanes by moving a lane from one index to another.
 */
export class ReorderLanes {
  static readonly type = '[MultiView] Reorder Lanes';

  /**
   * @param fromIndex The current index of the lane to move.
   * @param toIndex The target index to move the lane to.
   */
  constructor(
    public readonly fromIndex: number,
    public readonly toIndex: number
  ) {}
}

/**
 * Action to set a lane configuration as active.
 */
export class SetLaneActive {
  static readonly type = 'set active';

  /**
   * @param laneConfig The lane configuration to set as active.
   */
  constructor(readonly laneConfig: LaneConfig) {}
}
